import { useMemo } from 'react';
import { ColDef, FirstDataRenderedEvent, GridReadyEvent, ICellRendererParams, RowDataChangedEvent, SortChangedEvent, ValueGetterParams } from 'ag-grid-community';
import { IHeaderParams } from 'ag-grid-community';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import { IAllCentersGrid } from '@nkr/models/all-centers';
import { AgGridReact } from 'ag-grid-react';
import { GridWrapper } from './styles';
import { useAppHookContext } from '@nkr/utils/rest-api';
import { OrganType } from '@nkr/enums/organ-type';

interface IProps {
    centerData: IAllCentersGrid[],
    isAdmin: boolean,
    centerId: number,
    onGetPatientOutcomes: (centerId: number) => void
}

const Grid = (props: IProps) => {
    const { app: { site } } = useAppHookContext();

    const cols: ColDef[] = [
        {
            headerName: 'R #',
            colId: 'Rank',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>R #</SortableHeaderComponent>,
            valueGetter: (params: ValueGetterParams) => params.node.rowIndex + 1,
            sortable: false,
            width: 85
        },
        {
            colId: 'alias',
            field: 'alias',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Alias</SortableHeaderComponent>,
            width: 100,
            comparator: (valueA: string, valueB: string) => valueA.toLowerCase().localeCompare(valueB.toLowerCase()),
        },
        {
            colId: 'name',
            field: 'name',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Center Name</SortableHeaderComponent>,
            width: 450
        },
        {
            colId: 'city',
            field: 'city',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>City</SortableHeaderComponent>,
            width: 100
        },
        {
            colId: 'state',
            field: 'state',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>State</SortableHeaderComponent>,
            width: 100
        },
        {
            colId: 'isRemoteDonationCenter',
            field: 'isRemoteDonationCenter',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Is RDN Center</SortableHeaderComponent>,
            width: 100,
            hide: site.organType != OrganType.Kidney
        },
        {
            colId: 'contacts',
            field: 'contacts',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Contact</SortableHeaderComponent>,
            cellRendererFramework: (params: ICellRendererParams) => {
                let data = params.data as IAllCentersGrid
                let url = props.isAdmin ? `/admin/reports/all-centers/details/${data.id}` : `/center/${props.centerId}/reports/all-centers/details/${data.id}`

                return <div><a href={url}>Details</a></div>
            },
            sortable: false,
            width: 100,
            hide: site.organType != OrganType.Kidney
        },
        {
            colId: 'outomes',
            field: 'outcomes',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Outcomes</SortableHeaderComponent>,
            cellRendererFramework: (params: ICellRendererParams) => {
                let data = params.data as IAllCentersGrid

                return <div onClick={() => { props.onGetPatientOutcomes(data.id) }}><a>Patient Outcomes</a></div>
            },
            sortable: false,
            width: 100,
            hide: site.organType != OrganType.Kidney
        },
    ];

    const columnDefs = useMemo(() => cols, []);

    return (
        <GridWrapper>
            <AgGridReact
                defaultColDef={{
                    headerClass: 'list-header',
                    cellClass: 'list-cell',
                    sortable: true,
                    resizable: true
                }}
                columnDefs={columnDefs}
                rowData={props.centerData}
                suppressCellSelection={true}
                suppressContextMenu={true}
                getRowStyle={(params: ICellRendererParams) => {
                    if (params.node.rowIndex % 2 == 0) {
                        return { backgroundColor: '#f9f9f9' };
                    }
                }}
                headerHeight={30}
                noRowsOverlayComponentFramework={() =>
                    <div>No data for the selected parameters...</div>}
                onGridReady={(e: GridReadyEvent) => e.api.sizeColumnsToFit()}
                onFirstDataRendered={(e: FirstDataRenderedEvent) => e.api.sizeColumnsToFit()}
                onRowDataChanged={(e: RowDataChangedEvent) => e.api.sizeColumnsToFit()}
                onSortChanged={(e: SortChangedEvent) => {
                    e.api.refreshCells();
                }}
            />
        </GridWrapper>
    );
}


export default Grid;